/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { withRouter } from 'react-router';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import GridExample from './grid';
import ProcedureTypeGrid from './ProcedureTypeGrid';
import { cellHead, cellHead1 } from './tableHead';
import {
  getProcedureResultDetails,
  getProcedureTypeDetails,
} from '../store/actions';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { DEVELOPER } from '../../../../SharedModules/Errors/constantMessageData';

function ProcedureResult({ location }) {
  const { searchCriteria, isReadOnly } = location;
  const dispatch = useDispatch();
  const searchGetprocedureTypeDetails = (value) =>
    dispatch(getProcedureTypeDetails(value));
  const [processID, setProcessID] = useState(null);
  const [openCancel, setOpenCancel] = useState(false);
  const [spinnerLoader, setspinnerLoader] = useState(false);

  const searchProcedurResultDetail = (value) =>
    dispatch(getProcedureResultDetails(value));
  const procedureReuslt = useSelector((state) => {
    if (
      state &&
      state.sharedState &&
      state.sharedState.ProcedureResultReducer &&
      state.sharedState.ProcedureResultReducer.rebateSystemSerchResult
    ) {
      return state.sharedState.ProcedureResultReducer.rebateSystemSerchResult;
    }
    return [];
  });
  const getProcessDetails = useSelector((state) => {
    return state.sharedState.ProcedureResultReducer.procedureDetials;
  });

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const [isDeveloper, setIsDeveloper] = useState(false);
  useEffect(() => {
    const isDev = kcRoles?.userPrivileges.indexOf(DEVELOPER) !== -1;
    setIsDeveloper(isDev);
  }, [kcRoles]);

  const [open, setOpen] = useState(false);
  const [showBusinessCheckBox, setBussinessCheckBox] = useState(true);
  const [showDetailCheckBox, setShowDetailCheckBox] = useState(false);
  const [sucessMessage, setSucessMessage] = useState([]);

  const [tableDataForProceduerResult, setTableDataForProceduerResult] =
    useState(procedureReuslt);
  const [processDetails, setProcessDetails] = useState(getProcessDetails);
  const [copyProcedureDetails, setCopyProcedureDetails] =
    useState(getProcessDetails);
  const [fullScreenViewData, setFullScreenViewData] = useState(false);
  const [fullScreenViewInfo, setFullScreenViewInfo] = useState(false);

  const [information, setInFormation] = useState('');

  const onCellClicked = (value) => {
    setspinnerLoader(true);
    axios.post(serviceEndPoint.GET_PROCESS_DETAILS, value).then((res) => {
      setCopyProcedureDetails(res.data);
      let procedureDetial = res.data;
      setspinnerLoader(false);
      if (
        procedureDetial &&
        procedureDetial.length &&
        procedureDetial.length > 0
      ) {
        procedureDetial = procedureDetial.filter(
          (item) => item.processTypeCd === 'Business'
        );
      }
      setProcessDetails(procedureDetial);
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setCopyProcedureDetails(getProcessDetails);

    let procedureDetial = getProcessDetails;
    if (
      procedureDetial &&
      procedureDetial.length &&
      procedureDetial.length > 0
    ) {
      procedureDetial = procedureDetial.filter(
        (item) => item.processTypeCd === 'Business'
      );
    }
    setProcessDetails(procedureDetial);
    setspinnerLoader(false);
  }, [getProcessDetails]);

  useEffect(() => {
    window.localStorage.setItem(
      'searchCriteria',
      JSON.stringify(searchCriteria)
    );
    if (
      procedureReuslt &&
      procedureReuslt.length &&
      procedureReuslt[0].processId
    ) {
      window.localStorage.setItem('proccessId', procedureReuslt[0].processId);
    }
    const proccessId = window.localStorage.getItem('proccessId');
    if (proccessId) {
      searchGetprocedureTypeDetails({
        processId: Number(proccessId),
      });
    }
  }, []);

  const cancelPopUP = () => {
    setOpenCancel(true);
  };
  const handleCancelClose = () => {
    setOpenCancel(false);
  };
  const handleCancel = () => {
    setOpenCancel(false);
    setShowDetailCheckBox(false);
    setBussinessCheckBox(true);
  };
  useEffect(() => {
    if (procedureReuslt && procedureReuslt.length > 0) {
      const { processId } = procedureReuslt[0];
      window.localStorage.setItem('proccessId', processId);

      // searchGetprocedureTypeDetails({
      //   processId: processId,
      // });
      procedureReuslt.forEach((item, i) => {
        item.id = i;
        item.processDt = moment(new Date(item.processDt)).format('MM/DD/YYYY');
      });
    }
    setTableDataForProceduerResult(procedureReuslt);
  }, [procedureReuslt]);

  const onDelete = () => {
    setOpen(true);
  };
  const onDeleteRequestAPICall = () => {
    setOpen(false);
    setSucessMessage([]);
    setspinnerLoader(true);
    axios
      .post(serviceEndPoint.DELETE_PROCEDURE_RESULT, {
        processId: Number(processID),
      })
      .then(() => {
        const searchCriterias = window.localStorage.getItem('searchCriteria');
        setspinnerLoader(false);
        if (searchCriterias) {
          searchProcedurResultDetail(JSON.parse(searchCriterias));
        }
        setSucessMessage(['System successfully deleted the information']);
      });
  };

  return (
    <div className='tBillPanel'>
      <div className='panel tBillPanel-space devider-line pb-0'>
        <div>
          <CustomSeparator
            parent1='System'
            parent2='Procedure Results'
            parent3='Procedure Results Detail'
          />
        </div>
        <SaveCancelPopup
          open={open}
          title='Delete'
          onConfim={() => {
            onDeleteRequestAPICall();
          }}
          onCancel={() => {
            handleClose();
          }}
          moduleName='the selected record'
        />
        <SaveCancelPopup
          open={openCancel}
          title='Cancel'
          onConfim={() => {
            handleCancel();
          }}
          onCancel={() => {
            handleCancelClose();
          }}
        />
        {!(fullScreenViewData || fullScreenViewInfo) && (
          <div>
            <DisplaySuccessMessages successMessages={sucessMessage} />
            <div className='panel-header'>
              <div className='flex-block justify-end pb-1'>
                <div className='btn-wrapper float-right'>
                  <Button
                    className='btn btn-cancel'
                    onClick={cancelPopUP}
                    disabled={!isDeveloper || !processID || isReadOnly}
                  >
                    {' '}
                    <SVGComponent iconName='Icon-cancel' />
                    Cancel
                  </Button>
                  <Button
                    className='btn btn-success btn-save'
                    disabled={!isDeveloper || !processID || isReadOnly}
                    onClick={onDelete}
                  >
                    <SVGComponent iconName='Icon-delete-white' />
                    Delete
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {!fullScreenViewInfo && (
        <div className='panel tBillPanel-space pb-2'>
          <div className='clearfix' />
          <GridExample
            onCellClicked={onCellClicked}
            cellHead={cellHead}
            data={tableDataForProceduerResult}
            onSelect
            setProcessID={setProcessID}
            setSucessMessage={setSucessMessage}
            setBussinessCheckBox={setBussinessCheckBox}
            setShowDetailCheckBox={setShowDetailCheckBox}
            fullScreenView={fullScreenViewData}
            setFullScreenView={setFullScreenViewData}
          />
        </div>
      )}
      {!fullScreenViewData && (
        <>
          <div className='panel tBillPanel-space pb-0 pt-4'>
            <div className='clearfix' />
            <ProcedureTypeGrid
              cellHead={cellHead1}
              data={processDetails}
              checkBox
              setProcessDetails={setProcessDetails}
              copyProcedureDetails={copyProcedureDetails}
              setBussinessCheckBox={setBussinessCheckBox}
              showBusinessCheckBox={showBusinessCheckBox}
              showDetailCheckBox={showDetailCheckBox}
              setShowDetailCheckBox={setShowDetailCheckBox}
              setInFormation={setInFormation}
              fullScreenView={fullScreenViewInfo}
              setFullScreenView={setFullScreenViewInfo}
              isReadOnly={isReadOnly}
            />
          </div>

          <div className='clearfix' />
          <span className='text-black sub-label'> </span>
          {information.length > 109 ? (
            <div style={{ margin: '40px 0 15px 0', background: '#fff' }}>
              <fieldset
                className='custom-fieldset'
                style={{ paddingBottom: '30px' }}
              >
                <legend className='same-font-family'>Information</legend>
                <p>{information}</p>
              </fieldset>
            </div>
          ) : null}
        </>
      )}
      {spinnerLoader && <Spinner load={spinnerLoader} />}
    </div>
  );
}
export default withRouter(ProcedureResult);
